export const SET_WALLETS = 'WALLETS/SET_WALLETS'
export const SET_WALLET_TRANSACTIONS = 'WALLETS/SET_WALLET_TRANSACTIONS'
export const SET_PROMISED_PAYMENTS = 'WALLETS/SET_PROMISED_PAYMENTS'
export const SET_ACTIVE_WALLET_ID = 'WALLETS/SET_ACTIVE_WALLET_ID'
export const FETCH_WALLETS = 'WALLETS/FETCH_WALLETS'
export const CHANGE_ACTIVE_WALLET_ID = 'WALLETS/CHANGE_ACTIVE_WALLET_ID'
export const FETCH_WALLET_TRANSACTIONS = 'WALLETS/FETCH_WALLET_TRANSACTIONS'
export const FETCH_EXPIRED_PAYMENTS = 'WALLETS/FETCH_EXPIRED_PAYMENTS'
export const FETCH_WALLET_PROMISED_PAYMENTS = 'WALLETS/FETCH_WALLET_PROMISED_PAYMENTS'
export const RESET_WALLETS = 'WALLETS/RESET_WALLETS'
export const RESET_FILTERS = 'WALLETS/RESET_FILTERS'
export const SET_FILTERS = 'WALLETS/SET_FILTERS'
export const RESET_WALLET_TRANSACTIONS = 'WALLETS/RESET_WALLET_TRANSACTIONS'
